<template>
  <v-navigation-drawer
    clipped
    temporary
    app
    :permanent="drawer"
    right
    v-model="drawer"
    width="600px"
  >
    <div style="top: 0; z-index: 1; background: #fff; position: sticky;">
      <v-card-title
        class="text-primary d-flex justify-space-between align-center"
      >
        <span>Alterar custos</span>
        <small v-if="productName">Página({{ currentPage }})</small>
      </v-card-title>
      <v-card-subtitle v-if="productName" class="pt-2 text--secondary">
        {{ productName }}
      </v-card-subtitle>
    </div>
    <v-card-text class="mb-6 mt-3">
      <v-row>
        <v-col>
          <app-number-field
            label="P. Compra"
            v-model="form.purchase_price"
            @input="handleProductValuesChange()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <app-number-field
            v-model="form.st"
            label="ST"
            :prefix="'%'"
            @input="handleProductValuesChange()"
          />
        </v-col>
        <v-col>
          <app-number-field
            v-model="form.ipi"
            label="IPI"
            :prefix="'%'"
            @input="handleProductValuesChange()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6"
          ><app-number-field
            v-model="form.shipping"
            label="Frete"
            @input="handleProductValuesChange()"
        /></v-col>
      </v-row>

      <v-row>
        <v-col
          ><app-number-field v-model="form.cost" label="Custo" readonly
        /></v-col>
      </v-row>

      <v-row>
        <v-col
          ><app-number-field
            v-model="form.icms_credit"
            label="ICMS Entrada"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
        <v-col
          ><app-number-field
            v-model="form.icms_debt"
            label="ICMS Saída"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
      </v-row>
      <v-row>
        <v-col>
          <app-select
            v-model="selectedCompany"
            label="Preencher PIS/COFINS da empresa"
            :items="companyItems"
            item-text="text"
            item-value="id"
            return-object
            @change="handleCompanyChange($event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          ><app-number-field
            v-model="form.pis_credit"
            label="PIS Entrada"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
        <v-col
          ><app-number-field
            v-model="form.pis"
            label="PIS Saída"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
      </v-row>
      <v-row>
        <v-col
          ><app-number-field
            v-model="form.cofins_credit"
            label="COFINS Entrada"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
        <v-col
          ><app-number-field
            v-model="form.cofins"
            label="COFINS Saída"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
      </v-row>
      <!-- IBS e CBS são apenas informativos: não entram no cálculo -->
      <v-row>
        <v-col
          ><app-number-field v-model="form.ibs" label="IBS" :prefix="'%'"
        /></v-col>
        <v-col
          ><app-number-field v-model="form.cbs" label="CBS" :prefix="'%'"
        /></v-col>
      </v-row>

      <v-row>
        <v-col
          ><app-number-field
            v-model="form.commission"
            label="Comissão"
            :prefix="'%'"
            @input="handleProductValuesChange()"
        /></v-col>
      </v-row>
      <!-- <v-row>
        <v-col
          ><app-number-field
            v-model="form.desired_profit"
            label="Lucro Ideal"
            :prefix="'%'"
        /></v-col>
        <v-col
          ><app-number-field
            v-model="form.desired_profit"
            label="Preço Sugerido"
        /></v-col>
      </v-row> -->
      <v-row>
        <v-col
          ><app-number-field
            v-model="form.price_cash"
            label="Preço Av."
            @input="
              handleProductValuesChange();
              handlePriceCashChange();
            "
        /></v-col>
        <v-col
          ><app-number-field
            v-model="form.price_forward"
            label="Preço Pz."
            readonly
        /></v-col>
      </v-row>
      <v-row>
        <v-col
          ><app-number-field
            v-model="form.profit"
            label="Lucro"
            :prefix="'%'"
            readonly
            :allowNegative="true"
        /></v-col>
      </v-row>
    </v-card-text>
    <template v-slot:append>
      <div
        class="d-flex justify-space-between align-center pa-4"
        style="background-color: #f5f5f5"
      >
        <div>
          <v-btn
            class="text-capitalize mr-2"
            color="primary"
            @click="handleConfirm()"
          >
            Confirmar
          </v-btn>
          <v-btn @click="drawer = false" text class="text-capitalize">
            Cancelar
          </v-btn>
        </div>
        <div v-if="productName">
          <v-btn
            :disabled="isFirst"
            text
            class="text-capitalize mr-2"
            @click="handlePrev()"
          >
            <v-icon left>mdi-chevron-left</v-icon>
            Anterior
          </v-btn>
          <v-btn
            :disabled="isLast"
            text
            class="text-capitalize"
            @click="handleNext()"
          >
            Próximo
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import ProductCalcsMixin from "@/mixins/product/ProductCalcsMixin";

export default {
  mixins: [ProductCalcsMixin],

  props: {
    value: {},
    isFirst: Boolean,
    isLast: Boolean,
    productName: String,
    currentPage: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      drawer: false,

      companies: null,

      selectedCompany: null,

      form: {
        desired_profit: 0,
        commission: 0,
        pis: 0,
        cofins: 0,
        ibs: 0,
        cbs: 0,
        cost: 0,
        icms_debt: 0,
        icms_credit: 0,
        pis_credit: 0,
        cofins_credit: 0,
        shipping: 0,
        ipi: 0,
        st: 0,
        purchase_price: 0,
      },
    };
  },

  computed: {
    companyItems() {
      return (this.companies || []).map((company) => ({
        ...company,
        text: `${company.short_name || company.name} — PIS ${company.pis_credit}% / ${company.pis_debit}% · COFINS ${company.cofins_credit}% / ${company.cofins_debit}%`,
      }));
    },
  },

  methods: {
    handlePrev() {
      this.$emit("prev");
    },

    handleNext() {
      this.$emit("next");
    },

    async open() {
      this.setFormData();

      this.selectedCompany = null;

      this.drawer = true;

      await this.getCompanies();
    },

    async getCompanies() {
      if (this.companies) return;

      await this.$http
        .index("/company/company", { status: 1 })
        .then((response) => {
          this.companies = response.companies;
        });
    },

    // Apenas preenche os campos; o produto não guarda vínculo com a empresa
    handleCompanyChange(company) {
      if (!company) return;

      this.form.pis_credit = company.pis_credit;
      this.form.pis = company.pis_debit;
      this.form.cofins_credit = company.cofins_credit;
      this.form.cofins = company.cofins_debit;

      this.handleProductValuesChange();
    },

    setFormData() {
      this.form = JSON.parse(JSON.stringify(this.value));
    },

    handleConfirm() {
      this.$emit("input", this.form);
      if (this.productName) return;
      this.drawer = false;
    },

    handleProductValuesChange() {
      this.form.cost = this.calcCost(this.form);
      this.form.profit = this.calcProfit(this.form);
    },

    handlePriceCashChange() {
      this.form.price_forward = this.calcPriceForward(this.form);
    },
  },
};
</script>

<style></style>
